import request from '@/services/base/request'

export default {
  getUserIPData: (data: any) => request('https://www.cloudflare.com/cdn-cgi/trace', 'get', data, { headers: {} })
} as {[key: string]: MethodDecorator}

// https://ipinfo.io
